import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Scatter, Chart } from "react-chartjs-2";
import { localize } from "linksoft";
import CacheInfo from '../../cacheInfo';
import actions from "./actions";
import ChartBase from "../chartsBase/chart-base";
import FullscreenWrapper from "../chart-fullscreen-wrapper/chart-fullscreen-wrapper";
import drawPointLabelPlugin from "../chart-plugins/drawPointLabel";
import drawAliasOrNameLabelPlugin from "../chart-plugins/drawAliasOrNameLabel";
import drawInclinationLabelPlugin from "../chart-plugins/drawInclinationLabel";

const Resx = localize("App");

function mapStateToProps(state, ownProps) {
  const profileState = state.profile[ownProps.id || "_"] || {
    loading: true,
    data: [],
  };

  return {
    loading: profileState.loading,
    data: profileState.data,
    curvePoints: profileState.curvePoints,
    nominalPoints: profileState.nominalPoints,
    processingCurvePoints: profileState.processingCurvePoints,
    processingNominalPoints: profileState.processingNominalPoints,
  };
}

const mapDispatchToProps = {
  loadData: actions.loadData,
};

@connect(mapStateToProps, mapDispatchToProps)
class Profile extends ChartBase {
  static propTypes = {
    isNominalProfile: PropTypes.bool.isRequired,
    profileId: PropTypes.number,
    nominalProfileId: PropTypes.number,
    height: PropTypes.number,
    loading: PropTypes.bool,
    displayAliases: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.object),
  };

  static defaultProps = {
    isNominalProfile: false,
    id: "_",
  };

  componentWillMount() {
    Chart.pluginService.register({
      afterDatasetsDraw: (chart) => {
            drawPointLabelPlugin(chart);
            drawInclinationLabelPlugin(chart);
            drawAliasOrNameLabelPlugin(chart);
      },
    });
  }

  componentDidMount() {
    const {
      loadData,
      isNominalProfile,
      profileId,
      nominalProfileId,
      id,
    } = this.props;
    loadData(profileId, nominalProfileId, isNominalProfile, id);

    // fix for issue with printing when graph right edge is not completely visible
    try {
      if (window.matchMedia) {
        const mediaQueryList = window.matchMedia("print");
        mediaQueryList.addEventListener("change", (mql) => {
          if (mql.matches) {
            for (const id in Chart.instances) {
              Chart.instances[id].resize();
            }
          }
        });
      }
    } catch (e) {
      // ignore any error
      // apparently something was happening in this block which caused failure in conversion to PDF (charts were not rendered)
    }
  }

  render = () => {
    const { loading, data, height, style, profileId } = this.props;
    const size = height || (this.containerDivRef || {}).clientWidth;
    return (
      <div ref={(el) => (this.containerDivRef = el)}>
        {loading ? (
          this.progressLoader()
        ) : (
          <div>
            <FullscreenWrapper
              style={{ ...style, width: size, height: size, padding: "15px" }}
            >
              <Scatter
                ref={(el) => (this.chartRef = el)}
                options={this.profileChartOptions(data)}
                data={{ datasets: data }}
              />
            </FullscreenWrapper>
          </div>
        )}
      </div>
    );
  };

  profileChartOptions(data) {
    data = data || [];

    const stepSize = 1;
    const drawTicks = false;
    const unionData = [];
    data
      .map((i) => i.data)
      .forEach((array) => {
        unionData.push(...array);
      });
    const max = Math.max(
      ...unionData.map((i) => i.x).concat(unionData.map((i) => i.y))
    );
    const min = Math.min(
      ...unionData.map((i) => i.x).concat(unionData.map((i) => i.y))
    );
    const units = Math.ceil(Math.max(max, Math.abs(min)) / stepSize);
    const axisMax = units * stepSize;
    const axisMin = Math.sign(min) * axisMax;

    return {
      maintainAspectRatio: false,
      aspectRatio: 1,
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: Resx.App.ProfileChartTitle,
      },
      tooltips: {
        callbacks: {
          label: (tooltipItem, data) => {
            return (
              data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                .metadata.tooltipText || Resx.App.Profile
            ); //show measurement tooltip, or text 'Profile' form profile points
          },
        },
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 5,
          bottom: 0,
        },
      },
      scales: {
        xAxes: [
          {
            display: true,
            //labelString: Resx.App.CoordinateX,
            type: "linear",
            position: "bottom",
            gridLines: {
              color: "#888",
              drawOnChartArea: drawTicks,
              drawBorder: drawTicks,
              drawTicks: drawTicks,
            },
            ticks: {
              display: drawTicks,
              stepSize: stepSize,
              max: axisMax,
              min: axisMin,
            },
          },
        ],
        yAxes: [
          {
            display: true,
            //labelString: Resx.App.CoordinateY,
            type: "linear",
            position: "bottom",
            gridLines: {
              color: "#888",
              drawOnChartArea: drawTicks,
              drawBorder: drawTicks,
              drawTicks: drawTicks,
            },
            ticks: {
              display: drawTicks,
              stepSize: stepSize,
              max: axisMax,
              min: axisMin,
            },
          },
        ],
      },
    };
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./App/components/modules/profile/profile.js